import { routes } from "src/router";
import { defaultLocal, i18n } from "src/i18n";

export default function (doc) {
    const localePrefix = i18n.locale === defaultLocal.lang ? "" : `/${i18n.locale}`;

    if (doc.type === "home") {
        return localePrefix === "" ? "/" : localePrefix;
    }

    const route = routes.find(
        (r) => r.meta && r.meta.prismicHandle === doc.type && !r.redirect
    );

    if (route) {
        let path = route.path;
        if (doc.uid && path.includes(":uid")) {
            path = path.replace(":uid", doc.uid);
        }
        return localePrefix === "" ? path : `${localePrefix}${path}`;
    }

    return localePrefix === "" ? "/" : localePrefix;
}
